/**
 * URL工具函数
 */

/**
 * 获取URL参数值（支持处理多个?的情况）
 * @param {string} paramName - 参数名
 * @param {string} search - 可选的search字符串，默认使用window.location.search
 * @returns {string|null} 参数值
 */
export const getUrlParam = (paramName, search = null) => {
  if (typeof window === 'undefined') {
    return null
  }

  const searchString = search || window.location.search

  if (!searchString) {
    return null
  }

  // 处理多个?的情况：将第一个?之后的所有?替换为&
  // 例如: ?appType=21?key=value 会变成 ?appType=21&key=value
  const firstQuestionMarkIndex = searchString.indexOf('?')
  const normalizedSearch = firstQuestionMarkIndex >= 0
    ? searchString.substring(0, firstQuestionMarkIndex + 1) +
      searchString.substring(firstQuestionMarkIndex + 1).replace(/\?/g, '&')
    : searchString

  try {
    const params = new URLSearchParams(normalizedSearch)
    return params.get(paramName)
  } catch (error) {
    console.warn('解析URL参数失败:', error)
    return null
  }
}

export default {
  getUrlParam
}

